import type { FaireProductEntity } from "../../entity_types/product";

export const p_3a65c2d7mx: FaireProductEntity = {
  token: "p_3a65c2d7mx",
  type: "product",
  name: "Mentally I'm At The Cottage Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/935c846b5336211af06fe6fbcf363b1224891fc9c80c2d343fd79266a2868a87.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a8fe52babd85122ccedbadc3e271607347d0eae07cdbd57dc32a0babbec358f9.png",
    "https://cdn.faire.com/fastly/60d6aabca69865d3c3e44ffa8e5fdbe3ca5529f1e5ff2f7325c4338160748a92.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/a753259d6ce347946368007bafa24126efd6b9c4ff3fe7562ae779163ad1a11b.png",
    "https://cdn.faire.com/fastly/79fdfdb965b6547d7b6781b078ea86a9fdf14b258e992b1ae72f833649b9be7a.png"
  ],
  priceDollars: 6.75,
  description: "These socks are for when you “need space” but actually mean a lakeside escape, fueled by fresh air and heated rivalry. 🥵\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:53.574Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
